export default __webpack_public_path__ + "static/media/Panel_2_Stage1.2c1ec6ae.svg";